import styled from "styled-components";
import { FooterNovoConhecerContainerLogoProps } from "./FooterNovoConhecerLogo.types";
import { colors, devicesNovo } from "../../../utils/styled/_variables.styled";
import { gridNovoConhecer } from "../../../utils/styled/_grid.style";

export const FooterNovoConhecerContainerLogo = styled.div<FooterNovoConhecerContainerLogoProps>`
  ${gridNovoConhecer("")}
  background-color: ${(props) => props.$backgroundcolor || colors.greenDark};

  .footer__logo-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 0px;
  }

  .footer__logo {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .footer__logo {
    .cmp-image__image {
      height: 54px;
      width: 141px;
    }
    .cmp-image__link {
      .cmp-image__image {
        height: 34px;
        min-width: 60px;
        width: 100%;
      }
    }
  }
  @media ${devicesNovo.desktop} {
    .footer__logo-container {
      flex-direction: row;
      justify-content: space-between;
      padding-top: 50px;
    }

    .footer__logo:first-child {
      margin-right: auto;
    }

    .footer__logo-grid {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 40px;
    }

    .footer__logo-grid .footer__logo {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      max-width: 180px;
    }
  }

  @media ${devicesNovo.tablet} {
    .footer__logo-container {
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 10px 0px;
      padding-top: 30px;
    }

    .footer__logo:first-child {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 40px;
    }

    .footer__logo-grid {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      align-items: center;
      gap: 30px;
      width: 100%;
      max-width: 600px;
    }

    .footer__logo-grid .footer__logo {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      text-align: center;
      width: 100%;
      max-width: 120px;
    }
  }

  @media ${devicesNovo.mobile} {
    .footer__logo-container {
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 10px 0px;
      padding-top: 40px;
    }

    .footer__logo:first-child {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 20px;
    }

    .footer__logo-grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      max-width: 600px;
    }

    .footer__logo-grid .footer__logo {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      text-align: center;
      width: 100%;
      max-width: 90px;
    }
  }

  .footer__logo-divider {
    @media ${devicesNovo.tablet} {
    height: 1px;
    margin-top: 20px;
    background-color: ${colors.white};
    margin-bottom: 40px;
    }

    @media ${devicesNovo.mobile} {
    height: 1px;
    margin-top: 20px;
    background-color: ${colors.white};
    margin-bottom: 40px;
   }
  }
`;
